<template>
  <el-dialog class="x-message-dialog" width="60%" ref="dialog" :title="title" v-bind="$attrs" v-on="$listeners"
             :append-to-body="appendToBody" :visible="visible" @close="handleClose" :modal-append-to-body="modalAppendToBody"  :resizable="false">
    <div class="x-message-dialog-body">
      <el-table
        size="small"
        height="400px"
        :data="messageData"
        :cell-class-name="getCellClassName"
        border
      >
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column label="类型" prop="checkType" :formatter="checkTypeFormatter" width="100"></el-table-column>
        <el-table-column label="提示信息" prop="checkMsg"></el-table-column>
      </el-table>
    </div>
    <template v-slot:footer v-if="showContinueButton || showModifyButton">
      <div>
        <el-button size="small" v-if="showModifyButton" @click="handleModify">返回修改</el-button>
        <el-button type="primary" v-if="showContinueButton" size="small" @click="handleContinue">继续操作</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import {MESSAGE_INFO, MESSAGE_WARN, MESSAGE_ERROR, MESSAGE_OPERATION_CLOSE, MESSAGE_OPERATION_MODIFY, MESSAGE_OPERATION_CONTINUE} from '@/util/common-constant';

export default {
  name: 'XMessageDialog',
  props: {
    visible: Boolean,
    modalAppendToBody: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: '提示信息'
    },
    messageData: {
      type: Array,
      default: () => { return []; }
    },
    handleFn: Function
  },
  computed: {
    showContinueButton() {
      if (this.messageData.length < 1) {
        return false;
      }
      // 如果有error就不显示
      return !this.messageData.find(n => [MESSAGE_ERROR].includes(n.checkType));
    },
    showModifyButton() {
      if (this.messageData.length < 1) {
        return false;
      }
      // 如果有error就显示
      return this.messageData.find(n => [MESSAGE_ERROR, MESSAGE_WARN].includes(n.checkType));
    }
  },
  methods: {
    handleModify() {
      this.$emit('update:visible', false);
      this.handleFn && this.handleFn({type: MESSAGE_OPERATION_MODIFY});
    },
    handleContinue() {
      this.$emit('update:visible', false);
      this.handleFn && this.handleFn({type: MESSAGE_OPERATION_CONTINUE});
    },
    handleClose() {
      this.$emit('update:visible', false);
      this.handleFn && this.handleFn({type: MESSAGE_OPERATION_CLOSE});
    },
    checkTypeFormatter(row, column, cellValue) {
      if (cellValue === MESSAGE_INFO) {
        return '提示';
      }
      if (cellValue === MESSAGE_ERROR) {
        return '错误';
      }
      if (cellValue === MESSAGE_WARN) {
        return '警告';
      }
      return '未知';
    },
    getCellClassName({ row, column }) {
      if (column.property !== 'checkType') {
        return '';
      }
      const checkType = row.checkType;
      if (checkType === MESSAGE_INFO) {
        return 'x-message-dialog-info';
      }
      if (checkType === MESSAGE_ERROR) {
        return 'x-message-dialog-error';
      }
      if (checkType === MESSAGE_WARN) {
        return 'x-message-dialog-warn';
      }
      return '';
    }
  }
};
</script>
<style lang="scss">
@import "../../style/mixins/index";
.x-message-dialog-body {
  height: 400px;
}

.x-message-dialog-info {
  background-color: #c0c4cc !important;
}

.x-message-dialog-warn {
  background-color: #FF954F !important;
}

.x-message-dialog-error {
  background-color: #F37D7D !important;
}
</style>